import { Editor, track } from '@tldraw/tldraw'
import { ButtonGroup } from './ButtonGroup'
import { Button } from 'common/Prose/Toolbar/ToolbarBravo/WriterFormatToolbar/Button'
import { Button as BlazeButton } from 'components/Button'
import { ArrowSkip, FlipLeft, FlipRight } from 'blaze-ui/icons'
import { useActions } from '../VisualEditor/hooks/useActions'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'
import { ArrowUndo } from 'blaze-ui/icons/16'

interface Props {
  editor: Editor
}

export const HistoryButtonGroup = track(({ editor }: Props) => {
  const actions = useActions(editor)
  const isSystemRedesignEnabled = useIsSystemRedesign()

  if (isSystemRedesignEnabled) {
    return (
      <ButtonGroup>
        <BlazeButton
          aria-label="Undo"
          frontIcon={ArrowUndo}
          onPress={() => actions['undo'].onSelect()}
          isDisabled={!editor.getCanUndo()}
          size="sm"
          variant="tertiary"
        >
          Undo
        </BlazeButton>
        <BlazeButton
          aria-label="Redo"
          frontIcon={() => <ArrowSkip size={16} />}
          onPress={() => actions['redo'].onSelect()}
          isDisabled={!editor.getCanRedo()}
          size="sm"
          variant="tertiary"
        >
          Redo
        </BlazeButton>
      </ButtonGroup>
    )
  }

  return (
    <ButtonGroup>
      <Button
        aria-label="Undo"
        icon={() => <FlipLeft size={isSystemRedesignEnabled ? 18 : 20} />}
        onPress={() => actions['undo'].onSelect()}
        isDisabled={!editor.getCanUndo()}
      />
      <Button
        aria-label="Redo"
        icon={() => <FlipRight size={isSystemRedesignEnabled ? 18 : 20} />}
        onPress={() => actions['redo'].onSelect()}
        isDisabled={!editor.getCanRedo()}
      />
    </ButtonGroup>
  )
})
